import React from 'react'

import { getAspectRatioPadding } from './utils/getAspectRatioPadding'

import { TIconProps } from './iconProps'

const IconShield: React.FC<TIconProps> = (props) => {
  return (
    <div style={props.style} className={`select-none ${props.className || 'w-24'}`} onClick={props.onClick}>
      <div className="relative h-0" style={getAspectRatioPadding(props.aspectRatio)}>
        <svg xmlns="http://www.w3.org/2000/svg" className="w-full h-full left-0 top-0 absolute" viewBox="0 0 48 48">
          <g fill="none" fillRule="evenodd">
            <path
              fill="currentColor"
              d="M38.704 4.51c.578-.19 1.173.204 1.24.79l.007.113-.001 22.333c0 6.035-4.965 11.23-14.693 15.726l-.865.393c-.208.094-.44.11-.657.047l-.127-.047-.865-.393c-9.569-4.423-14.529-9.52-14.689-15.43l-.004-.296-.001-22.333c0-.648.633-1.105 1.247-.903 1.123.371 2.691.69 4.566.94l.438.057.846.1.436.045.895.085.46.04.467.036.954.066.98.055.5.024.504.021 1.283.041 1.31.024L24 6.05l1.065-.006 1.31-.024 1.283-.04.504-.022.5-.024 1.22-.07 1.18-.088.46-.039.896-.085.436-.046.846-.099c2.069-.258 3.795-.598 5.004-.997zm-.653 2.157l-.223.055c-1.736.41-3.985.731-6.542.943l-.553.043-1.06.073c-1.004.062-2.044.107-3.112.135l-.806.018-1.166.014h-1.178l-1.166-.014c-1.08-.02-2.137-.056-3.158-.11l-.76-.043-1.06-.073c-2.6-.195-4.907-.503-6.715-.9l-.38-.086-.224-.055.002 21.079c0 5.028 4.316 9.626 13.13 13.786l.46.215.46.21.46-.21c8.815-4.074 13.282-8.57 13.575-13.483l.011-.259.004-.26.001-21.078z"
            />
            <path
              fill="#3E7F24"
              d="M32.257 17.331c.369-.41 1.001-.444 1.412-.074.379.34.436.905.153 1.313l-.079.099-9.895 11c-.323.359-.851.432-1.256.19l-.099-.068-6.104-4.714c-.437-.337-.518-.965-.18-1.402.311-.404.87-.504 1.298-.251l.104.07 5.37 4.148 9.276-10.31z"
            />
          </g>
        </svg>
      </div>
    </div>
  )
}
export default IconShield
